import { render, staticRenderFns } from "./NotaDeConsulta.vue?vue&type=template&id=7b486de7&scoped=true&"
import script from "./NotaDeConsulta.vue?vue&type=script&lang=js&"
export * from "./NotaDeConsulta.vue?vue&type=script&lang=js&"
import style0 from "./NotaDeConsulta.vue?vue&type=style&index=0&id=7b486de7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b486de7",
  null
  
)

export default component.exports